import { Link, Navigate, useParams } from "react-router-dom";
import { beginnerDays } from "./BeginnerPath.jsx";
import { techniquesById } from "../data/techniques.js";
import { Icon, familyMeta } from "../components/Icons.jsx";
import Seo from "../components/Seo.jsx";

export default function BeginnerPathDay() {
  const { n } = useParams();
  const day = beginnerDays.find((d) => d.d === Number(n));
  if (!day) return <Navigate to="/beginner-path" replace />;
  const tech = techniquesById[day.techniqueId];
  const fam = familyMeta[day.family];
  const prev = day.d > 1 ? day.d - 1 : null;
  const next = day.d < 7 ? day.d + 1 : null;

  return (
    <>
      <Seo
        title={`Day ${day.d} · ${day.title} · Beginner Path`}
        description={`Day ${day.d} of the 7-day beginner meditation path. Today's doorway: ${tech.title}.`}
        path={`/beginner-path/day-${day.d}`}
      />
      <section className="section-night" style={{ paddingTop: 60, paddingBottom: 40 }}>
        <div className="container">
          <Link to="/beginner-path" style={{ color: "var(--gold)", textDecoration: "none", fontFamily: "var(--mono)", fontSize: 12, letterSpacing: "0.18em", textTransform: "uppercase" }}>
            ← 7-Day path
          </Link>
          <div style={{ display: "flex", gap: 20, alignItems: "baseline", marginTop: 28 }}>
            <div style={{ color: "var(--gold)", fontFamily: "var(--serif)", fontSize: 80, lineHeight: 1, fontWeight: 500 }}>
              {String(day.d).padStart(2, "0")}
            </div>
            <div>
              <div style={{ color: "var(--gold)", fontFamily: "var(--mono)", fontSize: 11, letterSpacing: "0.22em", textTransform: "uppercase" }}>
                Day {day.d} of 7 · Source verse {tech.sourceVerse} · {fam.label}
              </div>
              <h1 style={{ color: "var(--ivory)", fontFamily: "var(--serif)", fontWeight: 400, fontSize: "clamp(32px, 4.4vw, 54px)", lineHeight: 1.05, marginTop: 8 }}>
                {day.title}
              </h1>
            </div>
          </div>
          <p style={{ color: "rgba(248,241,231,0.78)", maxWidth: 640, marginTop: 22, fontSize: 17, lineHeight: 1.65 }}>
            Today's doorway is <em style={{ color: "var(--gold)" }}>{tech.title}</em>. Read once. Practice once. Then journal one line.
          </p>
        </div>
      </section>

      <section className="section-ivory">
        <div className="container">
          <div className="featured-wrap">
            <div className="featured-left">
              <div className="tech-block"><div className="lbl">Ancient Essence</div><p style={{ fontStyle: "italic" }}>"{tech.essence}"</p></div>
              <div className="tech-block modern"><div className="lbl">Modern Translation</div><p>{tech.modern}</p></div>
              <div className="tech-block">
                <div className="lbl">Best For</div>
                <div className="tech-tags" style={{ marginTop: 8 }}>
                  {tech.best.map((t) => <span key={t} className="tech-tag">{t}</span>)}
                </div>
              </div>
            </div>
            <div className="featured-right">
              <h4>Practice · {tech.time} minutes</h4>
              <ol className="steps">{tech.steps.map((s, i) => <li key={i}>{s}</li>)}</ol>
              <div className="warn"><b>Common mistake →</b> {tech.mistake}</div>
              <div style={{ marginTop: 28, padding: "18px 20px", background: "#0F172A", borderRadius: 12, color: "var(--ivory)" }}>
                <div style={{ fontFamily: "var(--mono)", fontSize: 10.5, letterSpacing: "0.2em", color: "var(--gold)", marginBottom: 8 }}>JOURNAL PROMPT</div>
                <div style={{ fontSize: 15, lineHeight: 1.6, color: "rgba(248,241,231,0.92)", fontStyle: "italic" }}>"{tech.prompt}"</div>
              </div>
              <div style={{ marginTop: 28, display: "flex", gap: 10, flexWrap: "wrap" }}>
                <Link className="btn btn-primary" to={`/technique/${tech.id}`}>Open Full Technique {Icon.arrowSm()}</Link>
                <Link className="btn btn-secondary" to="/journal" style={{ background: "transparent", color: "var(--copper)", border: "1px solid var(--border)" }}>
                  Write Reflection
                </Link>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 60, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 20 }}>
            {prev ? (
              <Link to={`/beginner-path/day/${prev}`} className="btn btn-secondary" style={{ background: "transparent", color: "var(--copper)", border: "1px solid var(--border)" }}>
                ← Day {prev}
              </Link>
            ) : <span />}
            {next ? (
              <Link to={`/beginner-path/day/${next}`} className="btn btn-primary">Day {next} {Icon.arrowSm()}</Link>
            ) : (
              <Link to="/40-day-challenge" className="btn btn-primary">Continue to 40-Day Challenge {Icon.arrowSm()}</Link>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
